import { PlessViewUtilsSub } from './../../../kymw00/pless-view-utils-sub.service';
import { KYMW0700Model } from './../kymw0700.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 商品文字情報登録クラス
 *
 * @export RegistTextInfoService
 * @class RegistTextInfoService
 * @extends {PlessJsonResponderSub}
 */

@Injectable()
export class RegistTextInfoService extends PlessJsonResponderSub<any> {
    // 処理に使用するModel
    private model: KYMW0700Model;
    private vo: any;
    private successFunc: Function;

    constructor(
        protected plessHttp: PlessHttp,
        protected dialogService: PlessDialogServiceSub
    ) {
        super(plessHttp, dialogService);
    }

    /**
     * bodyにセットする値を返す
     *
     * @private
     * @returns {PlessRequest} リクエストJSON
     * @memberof RegistTextInfoService
     */
    private getBody(): PlessRequest {

        let registJSON = [];
        let updateJSON = [];
        let deleteJSON = [];

        // 生協コードの分を作成して追加
        for (const currentTextInfoVO of this.vo.listTextInfo) {
            // 選択、未選択の数値表現
            let tempSelected: number = <number>0;

            // 選択・未選択を数値に変換
            if (currentTextInfoVO.selectedFlg) {
                tempSelected = 1;
            }

            const condition = ({
                TextKindNum: currentTextInfoVO.textKindNum,
                StringValue: PlessViewUtilsSub.trimDirection(currentTextInfoVO.stringValue.toString(), 1),
                DeleteFlg: currentTextInfoVO.deleteFlg,
                SelectedFlg: tempSelected,
                DispNum: currentTextInfoVO.dispNum,
            });

            // 削除フラグがtrue(削除でない)で、かつ、連番が初期値-1でない場合(DBから取得している値の場合)
            if (currentTextInfoVO.deleteFlg && currentTextInfoVO.textKindNum > -1) {
                // 更新対象へ追加する
                updateJSON.push({ condition })
                continue;
            } else if (currentTextInfoVO.deleteFlg) {
                // 削除フラグがtrue(削除でない)で、連番が存在しない(前の条件で連番が存在しないことは判明)
                // 追加対象へ追加する
                registJSON.push({ condition })
                continue;
            } else {
                // 削除フラグがfalse(削除)であるため、削除対象へ追加する(前の条件で判明している)
                deleteJSON.push({ condition })
                continue;
            }
        }

        return new PlessRequest({
            regist: {
                TextInfoMasterParameter: {
                    parameter: {
                        GoodsCode: this.vo.pCode,
                        TextKindId: this.vo.textKindID,
                    }
                },
                TextInfoMasterInsert: { combination: registJSON },
                TextInfoMasterUpdate: { combination: updateJSON },
                TextInfoMasterDelete: { combination: deleteJSON },
            }
        })
    }

    /**
     * API呼び出し
     *
     * @param model
     * @memberof RegistTextInfoService
     */
    execute(model: KYMW0700Model, vo: any, successFunc: Function = null): void {
        this.model = model;
        this.vo = vo;
        this.successFunc = successFunc;
        this.send('registTextInfo', this.getBody());
    }

    /**
     * API通信成功時の処理
     *
     * @param {*} data レスポンスデータ
     * @memberof RegistTextInfoService
     */
    success(data: any): void {
        // 選択でチェックされた文字情報の商品付属文字選択VOを作成、呼出元画面へ返却する
        this.model.kymw0700Component.updateParent();

        this.model.kymw0700Component.eventInfoSet_CLICKHandler();
        if (this.successFunc !== null) {
            this.successFunc(data);
        }
    }
}
